<script setup lang="ts">
  import { computed } from "vue";
  import { IconMenuClipboard, Text } from "@ui-kit";
  import { default as MainPageAction } from "./MainPageAction.vue";
  import { useUserInfoStore, useOrderListStore, useWidgetsStore } from "@src/store";
  import { useProfileOptions } from "@src/hooks";

  const { hasPermission } = useProfileOptions();
  const userInfoStore = useUserInfoStore();
  const orderListStore = useOrderListStore();
  const widgets_store = useWidgetsStore();

  const isAvailableAction = computed(() => {
    return hasPermission("mobile.order_list") && userInfoStore.shop?.config.options.orders.includes("pickup");
  });
</script>

<template>
  <MainPageAction v-if="isAvailableAction" @click="() => widgets_store.open('orders')" data-testid="action-orders">
    <template #icon>
      <IconMenuClipboard />
    </template>
    <template #text>
      <Text font="body-regular-18" :wrap="false">{{ $t("Запросы на вынос") }}</Text>
      <Text
        v-if="orderListStore.new > 0"
        class="badge-new"
        font="body-medium-12"
        color="white"
        data-testid="action-orders-badge"
      >
        {{ orderListStore.new }}
      </Text>
    </template>
  </MainPageAction>
</template>

<style scoped>
  .badge-new {
    position: absolute;
    right: 12px;
    background-color: var(--sf-base-icon-error);
    border-radius: 100px;
    padding: 2px;
    min-width: 20px;
    text-align: center;
  }
</style>
